import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ACTORS, DOCUMENTS, DocumentTypeRoleConfig } from 'projects/common/models/main';
import { ApiService } from 'projects/common/services/api.service';
import { noop } from 'rxjs';

interface ModalData {
  orgId: string;
  config?: DocumentTypeRoleConfig;
}

@Component({
  selector: 'app-document-type-role-config-modal',
  templateUrl: './config-modal.component.html',
  styleUrls: ['./config-modal.component.scss'],
})
export class DocumentTypeRoleConfigModalComponent implements OnInit {
  form!: FormGroup;
  isEdit: boolean;
  documentTypes = Object.values(DOCUMENTS);
  actorTypes = Object.values(ACTORS);

  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private dialogRef: MatDialogRef<DocumentTypeRoleConfigModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalData,
  ) {
    this.isEdit = !!data.config;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      documentType: [{ value: this.data.config?.documentType ?? '', disabled: this.isEdit }, Validators.required],
      issuerTypes: [this.data.config?.issuerTypes?.[0] ?? null],
      receiverTypes: [this.data.config?.receiverTypes ?? []],
      relatedTypes: [this.data.config?.relatedTypes ?? []],
    });
  }

  getFilteredActorTypes(category: 'issuer' | 'receiver' | 'related'): string[] {
    if (!this.form) return this.actorTypes;
    const issuer = this.form.get('issuerTypes')?.value;
    const receivers = this.form.get('receiverTypes')?.value || [];
    const related = this.form.get('relatedTypes')?.value || [];

    return this.actorTypes.filter(at => {
      if (category !== 'issuer' && at === issuer) return false;
      if (category !== 'receiver' && receivers.includes(at)) return false;
      if (category !== 'related' && related.includes(at)) return false;
      return true;
    });
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const raw = this.form.getRawValue();
    this.api.upsertDocumentTypeRoleConfig(this.data.orgId, raw.documentType, {
      issuerTypes: raw.issuerTypes ? [raw.issuerTypes] : [],
      receiverTypes: raw.receiverTypes,
      relatedTypes: raw.relatedTypes,
    }).subscribe({
      next: () => {
        this.api.log('toast.saved');
        this.dialogRef.close(true);
      },
      error: noop,
    });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
